export default __webpack_public_path__ + "static/media/GB.743b5ded.png";